export default "__VITE_ASSET__Cn00Ejru__"